import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const stateelogsConfig: TSPConfig = {
  key: 'stateelogs',
  name: 'State eLogs',
  imageName: 'StateELogs',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your State eLogs profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default stateelogsConfig;
